import StepBasedBackButton from '@/src/common/components/elements/Buttons/StepBasedBackButton'
import HeadlineEyebrow from '@/src/common/components/marketing/headlines/HeadlineEyebrow'
import { usePerfectGiftBoxContext } from '@/src/common/contexts/PerfectGiftBoxContext'
import { VisaBACVisited } from '@/src/common/utilities/gtag'
import {
    BACContainer,
    BACContainerLeft,
    BACContainerRight,
    ComponentContent,
} from '@/src/modules/build-a-card/StyledComponents'
import BoxStep1LeftContent from '@/src/modules/gift-box/content/BoxStep1LeftContent'
import BoxStep1RightContent from '@/src/modules/gift-box/content/BoxStep1RightContent'
import BoxStep2LeftContent from '@/src/modules/gift-box/content/BoxStep2LeftContent'
import BoxStep2RightContent from '@/src/modules/gift-box/content/BoxStep2RightContent'
import { LoadingWrapper } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { useEffect, useState } from 'react'
import { ClipLoader } from 'react-spinners'
import { MEDIUM_TYPE_PHYSICAL } from '@/prisma/schemaConstants'
import { FORM_FIELDS_WRAPPER_ID } from '@/src/modules/build-a-card/constants'

const VisaGiftBoxFlow = () => {
    const {
        currentStep,
        setCurrentStep,
        hideStep1,
        designName,
        designImage,
        defaultImage,
        denomination,
        cardQuantity,
    } = usePerfectGiftBoxContext()

    const [analyticWasSent, setAnalyticWasSent] = useState<boolean>(false)

    // push datalayer event
    useEffect(() => {
        if (designName && !analyticWasSent) {
            VisaBACVisited(
                ['eec.detail', 'view_item'],
                MEDIUM_TYPE_PHYSICAL,
                designName,
                denomination,
                cardQuantity,
                true
            )
            setAnalyticWasSent(true)
        }
    }, [analyticWasSent, cardQuantity, denomination, designName])

    // wait until the url params load to show the content
    if (!designName) {
        return (
            <LoadingWrapper>
                <ClipLoader size={50} />
            </LoadingWrapper>
        )
    }

    return (
        <ComponentContent>
            <BACContainer id={FORM_FIELDS_WRAPPER_ID}>
                <BACContainerLeft>
                    <StepBasedBackButton
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        hideBackButton={Boolean(currentStep < 2) || hideStep1}
                    />
                    {!hideStep1 && (
                        <HeadlineEyebrow
                            label={`Step ${currentStep} of 2`}
                            style={{ marginBottom: 20 }}
                        />
                    )}
                    {currentStep === 1 ? (
                        <BoxStep1LeftContent
                            designImage={designImage}
                            designName={designName}
                            defaultImage={defaultImage}
                        />
                    ) : (
                        <BoxStep2LeftContent />
                    )}
                </BACContainerLeft>
                <BACContainerRight>
                    {currentStep === 1 ? (
                        <BoxStep1RightContent
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                        />
                    ) : (
                        <BoxStep2RightContent />
                    )}
                </BACContainerRight>
            </BACContainer>
        </ComponentContent>
    )
}

export default VisaGiftBoxFlow
